import { render } from "./HelpForm.vue?vue&type=template&id=338f3c60"
import script from "./HelpForm.vue?vue&type=script&lang=js"
export * from "./HelpForm.vue?vue&type=script&lang=js"

import "./HelpForm.vue?vue&type=style&index=0&id=338f3c60&lang=scss"

import exportComponent from "/app/tmp/bambl/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__